import { navigate } from 'gatsby-link'
import React from 'react'
import BaseCandidatoCard from './BaseCandidatoCard'

const CandidatoCard = ({ candidato, rutaBase, partido }) => {
  return (
    <BaseCandidatoCard
      className="mb-12 pt-12 bg-white cursor-pointer"
      url={`${rutaBase}/${candidato.candidateId}`}
      partido={partido}
    >
      <div className="items-center">
        <p className="text-xs font-semibold">{candidato.nombre}</p>
        <p className="text-xs mt-4">{candidato.cargo}</p>
      </div>
    </BaseCandidatoCard>
  )
}

export default CandidatoCard
